
<template>
  <Teleport
    to="body"
  >
    <div
      v-if="miniPayVisible"
      class="nav-mini-pay-container"
    >
      <div
        class="nav-mini-pay"
      >
        <iframe
          id="miniPayIframe"
          class="nav-mini-pay-iframe"
          name="iframeContain"
          scrolling="no"
          :src="iframeSrc"
        >
          您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
        </iframe>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useEventBus } from '@common/logic';
import { EVENTS } from '@/common/bus';
import { useLoginStore } from '@/store/login-store';
import { commonOpenLogin } from '@/common/login';
import { DefaultLogger } from '@/common/logger';

const eventBus = useEventBus();
const isEvo = import.meta.env.EVO;
const loginStore = useLoginStore();
const isLogin = computed(() => loginStore.isLogin);

interface PlayParams {
  actionUrl: string;
  ptag: string;
  aid: string;
}

// web iframe协议
const baseUrl = 'https://film.qq.com/minipay/index.html?_source=13&aid_version=V0&_scene=2';

// evo 伪协议
const baseSchema = 'https://film.qq.com/minipay/index.html?from=mac.paymask';
// const evoVipSchema = 'qqlive://sso/parent=player&actiontype=0&minipayurl=https%3A%2F%2Ffilm.qq.com%2Fminipay%2F%3Ffrom%3Dmac.paymask';

const miniPayVisible = ref(false);
const iframeSrc = ref('');

const generateIframeSrc = (params: PlayParams) => {
  if (params?.actionUrl) {
    return params.actionUrl;
  }
  return `${baseUrl}&aid=${params?.aid}`;
};

const generateSchema = (params: PlayParams) => {
  if (params?.actionUrl) {
    return `qqlive://sso/actiontype=0&minipayurl=${encodeURIComponent(params.actionUrl)}`;
  }
  const schema = `${baseSchema}&aid=${params?.aid}`;
  return `qqlive://sso/actiontype=0&minipayurl=${encodeURIComponent(schema)}`;
};

const showMiniPay = (params: PlayParams) => {
  // 未登录
  if (!isLogin.value) {
    commonOpenLogin();
    return;
  }
  // 登录态
  if (isEvo) {
    vnContext.external.openQQLive(generateSchema(params));
  } else {
    iframeSrc.value = generateIframeSrc(params);
    miniPayVisible.value = true;
  }
};

const closeMiniPay = () => {
  iframeSrc.value = '';
  miniPayVisible.value = false;
};
eventBus.$on(EVENTS.MINIPAYMODAL, showMiniPay);
const originList = [
  'https://film.video.qq.com',
  'https://film.qq.com',
];

if (isEvo) {
} else {
  window.addEventListener(
    'message',
    (e) => {
  	try {
        if (originList.includes(e.origin)) {
          const data = JSON.parse(e.data);
          if (data.eventName === 'onClose') {
            closeMiniPay();
          }
          if (data.eventName === 'changeLogin') {
            window.txv.login.openLogin();
          }
          if (data.eventName === 'onSuccess') {
            setTimeout(() => location.reload(), 600);
          }
        }
      } catch (error) {
        DefaultLogger.log(error);
      }
    },
  );
}


</script>

<style lang="scss">
.nav-mini-pay-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
}

.nav-mini-pay {
  position: fixed;
  z-index: 10001;
  left: 50%;
  top: 50%;
  width: 896px;
  height: 684px;
  margin: -342px 0px 0px -448px;
}

.nav-mini-pay-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
